import { enqueueSnackbar, UploadMultipleFiles } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	RunE2ENbrRelationsRequest
} from '../requests/E2ENbrRelationsRequests.js';

export const RunE2ENbrRelations = (filesPath) => async (dispatch) => {
	await RunE2ENbrRelationsRequest(filesPath).then(response => {
		if (response.data.includes(':\\')) {
			dispatch(DownloadFile(response.data));
		} else {
			dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const E2ENbrRelationsUploadRun = (files) => async (dispatch) => {
	await UploadMultipleFiles(files).then(response => {
		dispatch(RunE2ENbrRelations(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
